import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
  GlameraIconBase,
  GlameraIconDefinition,
  GLAMERA_ICON_HOST_TEMPLATE,
} from '@glamera/animated-icons/core';

export const GLM_USER_ROUND: GlameraIconDefinition = {
  name: 'user-round',
  viewBox: '0 0 24 24',
  svg: `
    <circle class="glm-user-round-head" cx="12" cy="8" r="5"></circle>
    <path
      class="glm-user-round-curve"
      d="M20 21a8 8 0 0 0-16 0">
    </path>
  `.trim(),
};

@Component({
  standalone: true,
  selector: 'glamera-user-round-icon',
  template: GLAMERA_ICON_HOST_TEMPLATE,
  styleUrls: ['../../core/src/lib/base/icon-base.scss', './user-round.animation.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class UserRoundIconComponent extends GlameraIconBase {
  readonly iconDef = GLM_USER_ROUND;

  constructor(sanitizer: DomSanitizer, cdr: ChangeDetectorRef) {
    super(sanitizer, cdr);
  }
}
